<script lang="ts" setup>
import { ToastLocation } from '~/lib/models/ui/toast'

const store = useLayoutStore()
const { translateInterpolated } = useTranslation()

const topNotifications = computed(() =>
  store.toasts.filter(notif => notif.location === ToastLocation.TOP)
)
const bottomNotifications = computed(() =>
  store.toasts.filter(notif => notif.location === ToastLocation.BOTTOM)
)

const onRemovedToast = (key: string) => {
  store.removeNotification(key)
}
</script>

<template>
  <div class="z-[100]">
    <div
      class="fixed left-2/4 top-5 z-[100] w-full -translate-x-2/4 transform md:left-auto md:right-10 md:max-w-lg md:translate-x-0"
    >
      <TransitionGroup name="fade" tag="div" appear>
        <LazyToast
          v-for="notif in topNotifications"
          :key="notif.key"
          :identifier="notif.key"
          :type="notif.type"
          :location="notif.location"
          :duration="notif.duration"
          @removed="onRemovedToast"
        >
          <p v-dompurify-html="translateInterpolated(notif.content)" class="text-white"></p>
        </LazyToast>
      </TransitionGroup>
    </div>

    <div
      class="fixed bottom-5 left-2/4 z-[100] w-full -translate-x-2/4 transform md:left-auto md:right-10 md:max-w-lg md:translate-x-0"
    >
      <TransitionGroup name="fade" tag="div" appear>
        <LazyToast
          v-for="notif in bottomNotifications"
          :key="notif.key"
          :identifier="notif.key"
          :type="notif.type"
          :location="notif.location"
          :duration="notif.duration"
          @removed="onRemovedToast"
        >
          <p v-dompurify-html="translateInterpolated(notif.content)" class="text-white"></p>
        </LazyToast>
      </TransitionGroup>
    </div>
  </div>
</template>

<style>
.fade-enter-from {
  @apply opacity-0;
}

.fade-enter-to {
  @apply translate-x-0 opacity-100;
}

.fade-leave-from {
  @apply opacity-100;
}

.fade-leave-to {
  @apply translate-x-8 opacity-0;
}

.fade-enter-active,
.fade-leave-active {
  @apply transition-all duration-300 ease-in-out;
}
</style>
